import React from 'react';
import { AppStore } from './../Core/AppStore';
import { Storage } from './../Core/Storage';
import { CartProvider } from './../Providers/CartProvider';
import { Routes } from './../Core/Constants'


export default class CartHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount = () => {

		AppStore.on("Cart.AfterUpdate", () => {
			this.forceUpdate();
		});
		AppStore.on("Cart.CouponAdded", () => {
			this.forceUpdate();
		});

		CartProvider.validateCart();
	}

	getCount = (items) => {
		let count = 0;
		items.forEach((item) => {
			count = count + item.count;
		});
		return count;
	}

	render() {
		let cart = Storage.instance().cachedCart;
		console.log(cart);
		var T = window.Texts.cart;
		if (cart && cart.cartedProducts.length > 0) {
			return (
				<a href={Routes.Cart} id="header_cart" className="box cart not-empty" >
					<div className="count">
						{this.getCount(cart.cartedProducts)}
					</div>
					<span>{T.cartHeader}: {cart.priceTable.displayTotalPriceInclVat}
						{cart.coupon ? 
							<>
								<br />
								<div style={{ color: cart.coupon?.isApplicable ? 'green' : 'citrine', left: '-5px', position: 'relative' }}>
									<img src="content/img/barcode24.png" style={{ position: 'relative', top: '5px', height: '20px' }} /> {cart.coupon?.name}
								</div>
							</> : null}
					</span>
				</a>);
		}
		else {
			return (
				<a href="#" id="header_cart" className="box cart empty">
					<span>{T.cartHeader + ' ' + T.emtyCartHeader}
						{cart?.coupon ?
							<><br />
								<div style={{ color: cart?.coupon?.isApplicable ? 'green' : 'citrine', left: '-5px', position: 'relative' }}>
									<img src="content/img/barcode24.png" style={{ position: 'relative', top: '5px', height: '20px' }} /> {cart?.coupon?.name}
								</div>
							</> : null}
					</span>
				</a>);
		}
	}
}

const url = window.location.search;
const params = new URLSearchParams(url);
const urlCouponCode = params.get('couponCode');
if (urlCouponCode && (!Storage.instance().cart.coupon || Storage.instance().cart.coupon?.code != urlCouponCode)) {
	CartProvider.addCoupon(urlCouponCode);
}

//inicializace 
var elements = document.querySelectorAll("[data-role='app-cart-header']");
if (elements.length > 0) {
	elements.forEach(function (element) {
		if (element) {
			var temp = document.createElement("div");
			var container = element.parentNode;
			ReactDOM.render(<CartHeader />, temp);
			// and replace the child
			container.replaceChild(temp.childNodes[0], element);
		}
	})
}





